import { useMemo, RefObject } from 'react';
import { createPortal } from 'react-dom';
import ReCAPTCHA from 'react-google-recaptcha';

export const useGreenSkyRecaptcha = (recaptchaRef: RefObject<ReCAPTCHA>): JSX.Element => {
    return useMemo(() => {
        let recaptchaSiteKey = '6LflQQQfAAAAAFZdICA5_K31UbdgKWjSu6GIP2ce'; // Default: use production sitekey.
        const hostname = window.location.hostname;

        if (
            hostname.startsWith('localhost') ||
            hostname.endsWith('stage.servicetitan.com') ||
            hostname.endsWith('st.dev')
        ) {
            recaptchaSiteKey = '6LcyOgQfAAAAAGpRzn1ZHAiBhy3c-VB1MqAT3sqW';
        }

        return createPortal(
            <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaSiteKey} size="invisible" />,
            document.body,
        );
    }, [recaptchaRef]);
};
